import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { forceCheckInPatientAsync } from '../../../../redux/flows/portal/lobby'
import { useAppDispatch, useAppSelector } from '../../../../redux/store'
import { APIStatus } from '../../../../redux/types'

export const useUpcoming = () => {
  const navigate = useNavigate()
  const scrollRef = useRef<HTMLDivElement | null>(null)
  const dispatch = useAppDispatch()
  const forceCheckInPatientStatus = useAppSelector((state) => state.lobbyPortal.forceCheckInPatientStatus)
  const clinicId = useAppSelector((state) => state.studioAuth.studioDetails?.id)
  const longPressTimerRef = useRef<NodeJS.Timeout | null>(null)

  // Force check in patient
  const handleForceCheckInPatient = (visitId: string | null, clinicId: string | null, item: any) => {
    if (forceCheckInPatientStatus === APIStatus.pending) return
    if (
      item.visit?.status === 'booked' &&
      item.visit?.patient?.isQuestionareCompleted &&
      item.visit?.patient?.user?.profilePic &&
      item.visit?.patient?.user?.dob &&
      item.visit?.initialWaiver
    ) {
      if (visitId && clinicId) {
        dispatch(forceCheckInPatientAsync({ visitId: visitId, clinicId: clinicId }))
      }
    }
  }

  const handleLongPressStart = (item: any) => {
    // Clear any existing timeout first to prevent race conditions
    if (longPressTimerRef.current) {
      clearTimeout(longPressTimerRef.current)
      longPressTimerRef.current = null
    }

    const visitId = item.visit?.id || item.visitId
    const itemClinicId = item.visit?.clinicId || clinicId

    if (!visitId || !itemClinicId) return
    longPressTimerRef.current = setTimeout(() => {
      handleForceCheckInPatient(visitId, itemClinicId, item)
      longPressTimerRef.current = null
    }, 2000) // 2 seconds for long press
  }

  const handleLongPressEnd = () => {
    if (longPressTimerRef.current) {
      clearTimeout(longPressTimerRef.current)
      longPressTimerRef.current = null
    }
  }

  useEffect(() => {
    const savedScroll = localStorage.getItem('lobby-upcoming-scroll')
    if (savedScroll && scrollRef.current) {
      scrollRef.current.scrollTop = Number(savedScroll) || 0
    }

    // Cleanup: clear timeout on unmount to prevent accidental triggers
    return () => {
      if (longPressTimerRef.current) {
        clearTimeout(longPressTimerRef.current)
        longPressTimerRef.current = null
      }
    }
  }, [])

  return {
    scrollRef,
    navigate,
    forceCheckInPatientStatus,
    handleForceCheckInPatient,
    handleLongPressStart,
    handleLongPressEnd,
  }
}
